export const Initiative = {
	isInitiativeCreating: false,
	isCreateConsultationInitiative: false
};
